
import { css } from 'lit';
export default css`
.cta-event {
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
}

  @media (min-width: 768px) {.cta-event {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 3em
}
  }

  .cta-event--one-column {
    grid-gap: 0;
    grid-template-columns: 1fr;
  }

.info hr {
  margin: 1.5rem 0;
}

.header {
  margin: 1em 0;
}

.picture-host-date {
  display: flex;
  margin: 1rem 0 1.5rem;
  gap: 1rem;
  align-items: center;
}

@media (min-width: 1024px) {

.picture-host-date {
    gap: 2rem
}
  }

.host-picture {
  border-radius: 50%;
  border: 1px solid #E8C2FF;
  min-width: 108px;
  height: 108px;
  position: relative;
  overflow: hidden;
  display: block;
}

.host-picture img {
  position: absolute;
  max-width: 108px;
}

.event-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media screen and (min-width: 550px) {

.event-info {
    flex-direction: row;
    gap: 2rem
}
  }

@media (min-width: 1024px) {

.event-info {
    gap: 3rem
}
  }

.host-names, .event-date {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 1.125rem;
}

.host-names-title, .event-date-title {
  margin-bottom: 0.5rem;
}

hr {
  margin: 1rem 0;
  border-top-width: 2px;
  border-color: rgba(0, 0, 0, 0.1);
}

.event-body {
  margin: 1rem 0;
  font-size: 1.125rem;
  line-height: 150%;
}

@media (min-width: 1024px) {

.event-body {
    font-size: 1.25rem;
    line-height: 167%
}
  }

.event-body p {
    margin-bottom: 1rem;
  }

.event-host-name {
  line-height: 160%;
}`;